import Divider from "components/v2/Divider/Divider";

import { ScheduleProvider } from "@RequestFormV2/sections/Schedule/context";
import useShowConsigneeSection from "@RequestFormV2/sections/Schedule/hooks/useShowConsigneeSection";
import ClearanceSection from "@RequestFormV2/sections/Schedule/components/ClearanceSection";
import ConsigneeSection from "@RequestFormV2/sections/Schedule/components/ConsigneeSection";
import NotifyPartySection from "@RequestFormV2/sections/Schedule/components/NotifyPartySection";
import StopList from "@RequestFormV2/sections/Schedule/components/StopList";
import "./Schedule.scss";

function ScheduleContent() {
  const showConsignee = useShowConsigneeSection();

  return (
    <>
      <StopList />
      <ClearanceSection />
      {showConsignee && (
        <>
          <Divider className="mb-3xl" />
          <ConsigneeSection />
          <Divider className="mb-3xl" />
          <NotifyPartySection />
        </>
      )}
    </>
  );
}

export default function Schedule() {
  return (
    <ScheduleProvider>
      <ScheduleContent />
    </ScheduleProvider>
  );
}
